<template lang="pug">
section.info-hero(:class="{ 'has-image': !!image }")
  .info-hero__image(v-if="image" :style="{ backgroundImage: `url(${image})` }" aria-hidden="true")
  .info-hero__inner
    .info-hero__badge(v-if="badge") {{ badge }}
    h1.info-hero__title {{ title }}
    p.info-hero__desc(v-if="subtitle") {{ subtitle }}
    slot
</template>

<script>
// The hero band the info pages (About us, Privacy, Terms) share with
// Pricing: the same navy-to-teal gradient, a small uppercase pill, one
// title, a muted subtitle. An optional photograph sits behind it, desaturated
// and faded into the ground at the bottom so the page never has a hard
// image edge. The pages' copy is untouched; this is the frame around it.
export default {
  name: 'InfoHero',
  props: {
    badge: { type: String, default: '' },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    image: { type: String, default: '' },
  },
}
</script>

<style lang="scss">
// Same tokens as pricing.vue's .pricing-root, and fixed in both themes: these
// pages carry the marketing palette, not the app's.
.info-hero {
  --ih-primary-light: #5bb8d9;
  --ih-text-muted: #8a9bb5;
  --ih-ground: #0a1628;

  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 5.5rem 2rem 3.5rem;
  background: linear-gradient(165deg, #0a1628 0%, #0d2847 50%, #096b94 100%);
  color: #e4e8ef;

  &__image {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center 30%;
    filter: grayscale(1) brightness(0.9);
    opacity: 0.22;
    // Dissolve into the ground rather than end in an edge.
    -webkit-mask-image: linear-gradient(to bottom, #000 35%, transparent 100%);
    mask-image: linear-gradient(to bottom, #000 35%, transparent 100%);
    pointer-events: none;
  }
  &__inner {
    position: relative;
    max-width: 760px;
    margin: 0 auto;
  }
  &__badge {
    display: inline-block;
    background: rgba(9, 107, 148, 0.25);
    border: 1px solid rgba(9, 107, 148, 0.4);
    border-radius: 100px;
    padding: 6px 18px;
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--ih-primary-light);
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }
  &__title {
    font-size: clamp(2rem, 5vw, 3.2rem);
    font-weight: 800;
    color: #fff;
    line-height: 1.15;
    margin: 0 0 0.75rem;
    letter-spacing: -0.02em;
  }
  &__desc {
    font-size: 1.05rem;
    color: var(--ih-text-muted);
    max-width: 560px;
    margin: 0 auto;
    line-height: 1.7;
  }
}
// Signed out there is a fixed top navbar instead of the rail: clear it the
// way Pricing's hero does (7rem), so the pill isn't jammed under the bar.
body:not(.has-sidebar) .info-hero {
  padding-top: 7rem;
}
body.isMobile .info-hero {
  padding: 3rem 1.25rem 2.5rem;
  &__title { font-size: 1.8rem; }
}
</style>
